var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"system-error"}},[_c('div',{staticClass:"container pt-3"},[_c('b-card',{staticClass:"mt-1 form-box mx-auto text-center justify-content-center",attrs:{"body-class":"px-5"}},[_c('p',{staticClass:"mx-auto mt-5 mb-3 white-space-pre-wrap"},[_vm._v(_vm._s(_vm.error_msg))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }